import { lender_filter_result_hooks } from '@axo/shared/data-access/hooks';

export const useGetLenderFilterResult = (
  applicationID: string,
  requestIDs: string[]
) => {
  const lenderFilterResults = lender_filter_result_hooks.useLenderFilterResults(
    applicationID,
    requestIDs.filter((requestID) => requestID !== '')
  );

  const getLenderFilterResult = (requestID: string) => {
    if (!lenderFilterResults.data) return [];
    return lenderFilterResults.data?.Items.filter(
      (request) => request.LoanRequestID === requestID
    );
  };

  return { getLenderFilterResult };
};
